import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-bg-secondary p-6 text-center">
      <div className="max-w-md space-y-4">
        <h1 className="text-9xl font-extrabold tracking-widest text-primary animate-pulse">404</h1>
        <div className="bg-accent px-2 text-sm rounded rotate-12 absolute transform translate-y-[-2rem] font-bold text-accent-foreground inline-block">
          Page Not Found
        </div>
        <h2 className="text-2xl font-bold text-fg-primary pt-4">Oops! You seem to be lost.</h2>
        <p className="text-fg-secondary">
          The page you are looking for does not exist or has been moved. Let's get you back on track.
        </p>
        <div className="pt-6">
          <Button asChild variant="default" size="lg">
            <Link to="/dashboard">Go back to Dashboard</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
